module.exports = __webpack_public_path__ + "media/1alB-d-duh.1def50d3.mp3";